/**
 * 在uni-bridge.js中监听到UniApp消息，同时页监听Flutter消息 这里统一处理接受UniApp消息
 * @param {message} 消息体
 * UniApp消息:
 *   AppWxAuthLoginSuccess    登录成功消息
 *   AppWxAuthLoginError      登录失败消息
 *   H5PageBack               页面回退消息
 * Flutter消息:
 *   FlutterHomeMenu          首页菜单跳转消息
 *   FlutterWxLogin           微信登录消息
 */
import { setLocalStorage } from "@/utils";
import useUsersStore from "@/stores/user";
import useRefreshStore from "@/stores/refresh";
import router from "@/router/index";
import useWindowsStore from "@/stores/windows";

const handleUniMessage = (message) => {
  const userStore = useUsersStore();
  const refreshStore = useRefreshStore();
  const windowsStore = useWindowsStore();
  console.log("接受自UniApp or Flutter消息", message);
  if (message) {
    const type = message.type;
    switch (type) {
      case 'AppWxAuthLoginSuccess':
        handleAppWxAuthLogin(message, userStore, refreshStore);
        break;
      case 'AppWxAuthLoginError':
        console.error("登录失败消息", message);
        break;
      case 'H5PageBack':
        handleH5PageBack();
        break;
      case 'FlutterHomeMenu':
        handleFlutterHomeMenu(message, windowsStore);
        break;
      case 'ToKLineDetail':
        handleFlutterHomeMenu(message, windowsStore);
        break;
      case 'FlutterWxLogin':
        handleFlutterWxLogin(message, userStore, refreshStore);
        break;
      case 'FlutterLoginOut':
        handleFlutterLoginOut(message, userStore, refreshStore);
        break;
      default:
        break;
    }
  }
};

// 处理UniApp登录成功消息
const handleAppWxAuthLogin = (message, userStore, refreshStore) => {
  const { token, user } = message.data;
  // 保存用户信息
  setLocalStorage("token", token);
  userStore.setNewUserInfo(user);
  setLocalStorage("uc_weixin_unionId_qs", user.userName);
  userStore.setLoginPopup(false);
  refreshStore.setPageRefreshData(true);
};

// 处理页面返回消息
const handleH5PageBack = () => {
  if (router?.options?.history?.state?.back) {
    router.back();
  } else {
    // 不存在页面回退了  用户在此回退操作时   通知app，退出app
    window.postMessageToUniApp({
      type: 'needGoBack',
      value: 'H5已经没有页面可以回退了'
    });
  };
};

// 处理Flutter App首页菜单跳转H5个股K线消息
const handleFlutterHomeMenu = (message, windowsStore) => {
  const { data } = message;
  sessionStorage.setItem("code", data.code);
  windowsStore.setChartsTabIndex(data.tabIndex);
  data?.windowList ? windowsStore.setWindowList(data.windowList) : '';
};
// 处理Flutter App微信登录消息
const handleFlutterWxLogin = (message, userStore, refreshStore) => {
  const { token, user } = message?.data || {};
  // 登录信息不完整  反馈给Flutter App
  if (!token || !user) {
    const payload = { type: 'OnLoginResult', data: { loginResult: false, loginInfo: message.data } };
    window.H5ToFlutterMes.postMessage(JSON.stringify(payload));
    return false;
  };
  // 保存用户信息
  setLocalStorage("token", token);
  userStore.setNewUserInfo(user);
  setLocalStorage("uc_weixin_unionId_qs", user.userName);
  userStore.setLoginPopup(false);
  refreshStore.setPageRefreshData(true);
};
// 处理Flutter App退出登录消息
const handleFlutterLoginOut = (message, userStore, refreshStore) => {
  localStorage.clear();
  sessionStorage.clear();
  userStore.setNewUserInfo({});
  refreshStore.setPageRefreshData(false);
};

export default handleUniMessage;
